// extracted by mini-css-extract-plugin
export default {"button":"_1GUumofseuYXwN5oWI2HaS"};